var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_12519_21463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.2932 13.6165C16.7702 13.3551 16.4453 12.8293 16.4453 12.2446V8.78906C16.4453 5.77805 14.3697 3.24295 11.5742 2.5386C11.6916 2.30316 11.7578 2.03812 11.7578 1.75781C11.7578 0.788574 10.9692 0 10 0C9.03076 0 8.24219 0.788574 8.24219 1.75781C8.24219 2.03812 8.30841 2.30316 8.42575 2.5386C5.63034 3.24295 3.55469 5.77805 3.55469 8.78906V12.2446C3.55469 12.8293 3.22983 13.3551 2.70676 13.6166C1.78406 14.0779 1.21094 15.0052 1.21094 16.0367V17.6562H7.65625C7.65625 18.9487 8.70758 20 10 20C11.2924 20 12.3438 18.9487 12.3438 17.6562H18.7891V16.0367C18.7891 15.0052 18.2159 14.0779 17.2932 13.6165ZM10 1.17188C10.323 1.17188 10.5859 1.43478 10.5859 1.75781C10.5859 2.08084 10.323 2.34375 10 2.34375C9.67697 2.34375 9.41406 2.08084 9.41406 1.75781C9.41406 1.43478 9.67697 1.17188 10 1.17188ZM10 18.8281C9.35379 18.8281 8.82812 18.3025 8.82812 17.6562H11.1719C11.1719 18.3025 10.6462 18.8281 10 18.8281ZM17.6172 16.4844H2.38281V16.0367C2.38281 15.452 2.70767 14.9261 3.23074 14.6646C4.15344 14.2033 4.72656 13.2761 4.72656 12.2444V8.78906C4.72656 5.88135 7.09229 3.51562 10 3.51562C12.9077 3.51562 15.2734 5.88135 15.2734 8.78906V12.2446C15.2734 13.2761 15.8466 14.2033 16.7693 14.6648C17.2923 14.9261 17.6172 15.452 17.6172 16.0367V16.4844Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12519_21463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.286f8aa6c8a3541cba67d1adad682682.svg";
export { ForwardRef as ReactComponent };